<div class="row justify-content-center py-5 padding">
  <div class="col-12 d-flex align-items-center justify-content-center">
    <img [src]="imagen" height="100%" width="100%" class="logo_destinux">
  </div>
</div>
